// Tenant/site/revision values come exclusively from the authenticated server response.
let acceptedToken = null, acceptedUser = null, epoch = 0;
export const ACCESS_CHANGED = 'autotu:access-changed';
export function bindApiSession(token, user = null) {
  if (token !== acceptedToken || identityScope(user) !== identityScope(acceptedUser)) epoch++;
  acceptedToken = token; acceptedUser = user;
}
export function isApiSessionBound(token) { return token === acceptedToken; }
export function apiSessionScope() { return {epoch, user:acceptedUser}; }
export function invalidateApiAccess() {
  acceptedToken = null; epoch++;
  window.dispatchEvent(new Event(ACCESS_CHANGED));
}
export function browserScope(api, userId, tenantId, ...resource) {
  const site = acceptedUser?.tenant_id === tenantId && acceptedUser?.id === userId
    ? [{site: acceptedUser.active_site_id, revision: acceptedUser.access_revision}] : [];
  return [api, {tenant: tenantId}, userId, ...site, ...resource];
}
// Serialized start of every browserScope key of one account (it always continues with ',').
export function browserScopePrefix(api, userId, tenantId) {
  return JSON.stringify([api, {tenant: tenantId}, userId]).slice(0, -1) + ',';
}
export function identityScope(user) {
  return JSON.stringify([user?.tenant_id || null, user?.id || null, user?.role || null, user?.active_site_id,
    user?.access_revision, user?.effective_permissions, user?.allowed_site_ids, user?.driver_assignment_fingerprint, user?.access_version]);
}
export function sessionChangedError() {
  const error = new Error('La sessione è cambiata. Riapri l’operazione con l’account corrente.');
  error.name = 'AbortError'; error.code = 'ERR_SESSION_CHANGED'; return error;
}
export function captureSession(tokenKey = 'autotu_token') {
  const token = localStorage.getItem(tokenKey), capturedEpoch = epoch;
  const isCurrent = () => localStorage.getItem(tokenKey) === token && capturedEpoch === epoch;
  return {isCurrent, assertCurrent: () => {if (!isCurrent()) throw sessionChangedError();}};
}
